import basicReduxGenerator from './basic'
import commonReduxGenerator from './common'
import listReduxGenerator from './list'
import scrollReduxGenerator from './scroll'
import dictReduxGenerator from './dict'

export {
  basicReduxGenerator,
  commonReduxGenerator,
  listReduxGenerator,
  scrollReduxGenerator,
  dictReduxGenerator
}
